import DraggableCell from './DraggableCell';

export default DraggableCell;
